import { createSlice } from '@reduxjs/toolkit';

const reducerName = 'pendingActivitiesData';
const initialState = {
  currentTab: 'overdue',
  sort: {
    id: 'time_in_stage',
    label: 'Time In stage (Descending)',
    element: 'time_in_stage',
    order: 'desc',
  },
  jobScope: 'my-jobs',
  filters: {
    ats_job_id: [{ id: 'all', name: 'All' }],
  },
  metrics: {
    data: {
      overdue: 0,
      needs_scheduling: 0,
      needs_decision: 0,
      needs_offer: 0,
      needs_action: 0,
    },
    isLoading: false,
  },
  overdue: { data: [], meta: {}, isLoading: false },
  needs_scheduling: { data: [], meta: {}, isLoading: false },
  needs_action: { data: [], meta: {}, isLoading: false },
  needs_decision: { data: [], meta: {}, isLoading: false },
  needs_offer: { data: [], meta: {}, isLoading: false },
  page: {
    number: 0,
  },
};

const { reducer, actions: pendingActivitiesActions } = createSlice({
  name: reducerName,
  initialState,

  reducers: {
    setActivitiesMetrics: (state, { payload }) => {
      const { counts } = payload;
      const {
        overdue,
        needs_scheduling,
        needs_action,
        needs_decision,
        needs_offer,
      } = counts;
      state.metrics.data.overdue = overdue || 0;
      state.metrics.data.needs_scheduling = needs_scheduling || 0;
      state.metrics.data.needs_action = needs_action || 0;
      state.metrics.data.needs_decision = needs_decision || 0;
      state.metrics.data.needs_offer = needs_offer || 0;
      state.metrics.isLoading = false;
    },

    setActivitiesTab: (state, { payload }) => {
      state.page = initialState.page;
      state.currentTab = payload;
    },

    setActivitiesLoading: (state) => {
      state.metrics.isLoading = true;
      state[state.currentTab].isLoading = true;
    },

    setActivities: (state, { payload }) => {
      const { data = [], meta = {} } = payload;
      state[state.currentTab].data = data;
      state[state.currentTab].meta = meta;
      state[state.currentTab].isLoading = false;
    },

    applyActivitiesFilter: (state, { payload }) => {
      const { key, value } = payload;
      state.page = initialState.page;
      state.filters[key] = value;
    },

    applyActivitiesJobScope: (state, { payload }) => {
      state.jobScope = payload;
      state.page = initialState.page;
      if (payload !== 'specific-jobs') {
        state.filters.ats_job_id = [{ id: 'all', name: 'All' }];
      }
    },

    applyPage: (state, { payload }) => {
      const { page } = payload;
      state.page.number = page;
    },

    applyActivitiesSort: (state, { payload }) => {
      state.sort = payload;
    },
    resetActivities: (state) => {
      state = { ...initialState };
    },
  },
});

export { pendingActivitiesActions };
export default reducer;
